import React from "react";
import { useState,useEffect } from "react";
import { DataGrid } from '@mui/x-data-grid';
import { configData } from "../config";
import { Helmet } from 'react-helmet';
import { Link } from '@mui/material';
import SalespersonSidebar from "./SalespersonSidebar";
import './classes/ResourceLibrary.css';
import { useLocation } from 'react-router-dom';
import AgentBackendSidebar from "./AgentBackendSidebar";
import ScoutSidebar from "./ScoutSidebar";
import { useNavigate  } from 'react-router-dom';

// Icon URLs 
const ICONS = {
  folder: "/images/folderopen.gif",
  file: "/images/file.gif",
  web: "/images/link.gif",
};

// Decide icon based on type and url
const getIconForRow = (row) => {
  const url = row.url?.toLowerCase() || "";
  if (row.type === "folder") return ICONS.folder;
  if (url.match(/\.(pdf|docx?|xlsx?|pptx?|zip)$/)) return ICONS.file;
  return ICONS.web;
};
const domainName = window.location.host.replace(/^https?:\/\//, '');
const loggedin_uid = localStorage.getItem('uid');

const ResourceLibrary = ()=>{
    const columns = [
    {
        field: 'title',
        headerName: 'Title',
        headerClassName: 'super-app-theme--header',
        minWidth: 100, 
        flex:1, 
        sortable: false,
        filterable: false, 
           renderCell: (params) => (
      <div dangerouslySetInnerHTML={{ __html: params.value }} />
    ),
        
      },
       {
        field: 'url',
        headerName: 'URL',
        headerClassName: 'super-app-theme--header',
        minWidth: 100, 
        flex:1, 
        sortable: false,
        filterable: false,     
           renderCell: (params) => (
               <div dangerouslySetInnerHTML={{ __html: params.value }} />
                ),
      },
       {
        field: 'operations',
        headerName: 'Operations',
        headerClassName: 'super-app-theme--header',
        minWidth: 100, 
        flex:1, 
        sortable: false,
        filterable: false,     
           renderCell: (params) => (
            <>
                 <div dangerouslySetInnerHTML={{ __html: params.value }} />
                </>
                ),
      },
    ];

        const [columnVisibilityModel, setColumnVisibilityModel] = React.useState({
          title: true,
          url: true,
          operations: true, // Initially visible
        });
        
       /* Pagination, filter config starts here */
        const [rows, setRows] = React.useState([]);
        const [rowCount, setRowCount] = React.useState(0);
        const [paginationModel, setPaginationModel] = React.useState({ page: 0, pageSize: 50 });
        const [sortModel, setSortModel] = React.useState([]);
        const [filterModel, setFilterModel] = React.useState({ items: [] });
        const [category, setCategory] = useState("0");
        const [selectedRows, setSelectedRows] = useState([]);
        const [categoryOptions, setcategoryOptions] = useState({});
       const[message,setMessage] = useState([]);
        const [loading, setIsLoading] = useState(false);
       const location  = useLocation();
        const urlParams = new URLSearchParams(location.search);
        const tid = urlParams.get('tid');
        const [formData, setFormData] = useState({ category_id: tid });

        const[userLoggedInRoles,setUserLoggedInRoles] = useState([]);
        
        const successMessage = location.state?.message; // Access the message
             window.history.replaceState({}, '');
        const handleChange = (event) => {
          const { name, value } = event.target;
          setFormData((prev) => ({ ...prev, [name]: value }));
        };
        const app_url = configData.APP_URL;
        useEffect(() => {
            Promise.all([
           getresourcelibraryfolderlist(),
           checkpermissionforpageaccess(),
           getuserloggedinroles()
            ])
            .then(() => {
             
              setIsLoading(false);
            })
          },[]);


    async function getuserloggedinroles() {
   
         try {
            const response = await fetch(
                app_url+'viewprofile/getuserloggedinrolesid',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
               
               setUserLoggedInRoles(responsedata.data.roles);
            } 
        } catch (err) {
            
         }
       
  }
          
         async function getresourcelibraryfolderlist() {
    
        try {
      
            const response = await fetch(
                app_url+'smwwagency/getresourcelibraryfolderlist',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setcategoryOptions(responsedata.data.result);
               
            } 
        } catch (error) {
        console.error(error);
      }finally {
            
          }
        
  }

    // React.useEffect(() => {
    //   if (location.pathname === '/resource_library_view') {
    //     setColumnVisibilityModel(prevModel => ({
    //       ...prevModel,
    //       operations: false, // Hide 'operations' 
    //     }));
    //   } else {
    //     setColumnVisibilityModel(prevModel => ({
    //       ...prevModel,
    //       operations: true, // Show 'operations'
    //     }));
    //   }
    // }, [location.pathname]);

    React.useEffect(() => {
      if (userLoggedInRoles.includes(configData.ROLE_SAADMIN)) {
        setColumnVisibilityModel(prevModel => ({
          ...prevModel,
          operations: true, // Show 'operations' 
        }));
      } else {
        setColumnVisibilityModel(prevModel => ({
          ...prevModel,
          operations: false, // Hide 'operations'
        }));
      }
    }, [userLoggedInRoles, configData]);

    React.useEffect(() => {
          const fetchData = async () => {
            // Simulate API call to your server
            // In a real application, replace this with your actual fetch logic
             try {
               setIsLoading(true); 
            const response = await fetch(app_url+'smwwagency/getmanageresourcelibrarylist', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                page: paginationModel.page,
                pageSize: paginationModel.pageSize,
                sortModel,
                filterModel,
                tid:tid,
              }),
            });
            const data = await response.json();
            console.log(data.data.rows);
            setRows(data.data.rows);
            setRowCount(data.data.totalRowCount); // Server should return totalRowCount
           // console.log("Type of totalRowCount:", typeof data.data.totalRowCount);
          }  catch (error) {
                  console.error('Error fetching data:', error);
                } finally {
                  setIsLoading(false); // Set loading to false after fetch completes (success or error)
                }
        
      
          };
      
          fetchData();
        }, [paginationModel, sortModel, filterModel]); // Re-fetch data when these change
        
          async function checkpermissionforpageaccess() {
       
          if(domainName === configData.RSMWW_SCOUT_DOMAIN) {
               const response = await fetch(
                    app_url+'smwwscout/checkpermissionforotherpageaccess?uid='+loggedin_uid,
                   {
                       method: "GET",
     
                       headers: {
                       'Content-Type': 'application/json',
                       },
                   }
               )           
               const responsedata = await response.json();
               if(responsedata.data.msg === "Success") {
                   
               } 
                if(responsedata.data.msg === "Error") {
                   setMessage(responsedata.data.result);
               } 
              }
              if(domainName === configData.RSMWW_AGENCY_DOMAIN) {
               const response = await fetch(
                    app_url+'smwwagency/checkpermissionforotherpageaccess?uid='+loggedin_uid,
                   {
                       method: "GET",
     
                       headers: {
                       'Content-Type': 'application/json',
                       },
                   }
               )           
               const responsedata = await response.json();
               if(responsedata.data.msg === "Success") {
                   
               } 
                if(responsedata.data.msg === "Error") {
                   setMessage(responsedata.data.result);
               } 
              }
          
       }
      //  const navigate = useNavigate();
    const handleSubmit = async (e) => {
      e.preventDefault();

      // Reset pagination state
      setPaginationModel({
        page: 0,
        pageSize: 50,
      });
      try {
        setIsLoading(true);
        const response = await fetch(app_url+'smwwagency/getmanageresourcelibrarylist', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            page: 0,
            pageSize: 50,
            sortModel,
            filterModel,
            tid:tid,
          }),
        });
        const data = await response.json();
        console.log(data.data.rows);
        setRows(data.data.rows);
        setRowCount(data.data.totalRowCount); // Server should return totalRowCount
      }  catch (error) {
            console.error('Error fetching data:', error);
           } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
           }
          window.location.href='/resource_library?tid='+formData.category_id;    
          
          if (formData.category_id === "0" || formData.category_id === 0 || formData.category_id === null) {
            window.location.href='/resource_library';  
          }
          // console.log("Selected Category ID:", formData.category_id);
        };

    return(
        <div id="main">
           <Helmet><title>Resource Library</title></Helmet>
            <div className="left"></div>
            <div className="center left-center">
              {message.length > 0 ? (
                <div>
                  {message.map((item, index) => {
                    return <><div dangerouslySetInnerHTML={{ __html: item }} /><br /></>
          
                  })}  
                </div>
              ) : (
                <div className="resource-library-container">
                    <h1>Resource Library</h1>
                     {successMessage && (
                        <div className="set-message-done">
                          <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span> {successMessage}
                        </div>
                        )}
                    { tid > 0 && (
                        <span>
                          <a href="resource_library">Back</a> {" | "}
                        </span>
                      )}
                    {((userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN))) &&
                      <a href="/node/add/resource-library">+ Create new</a>
                    }
                      <form onSubmit={handleSubmit}>
                        <div className="form-item">
                          <label>
                            Category:&nbsp;
                            <select name="category_id" value={formData.category_id} onChange={handleChange}>
                              {
                              categoryOptions.length > 0 && (
                              categoryOptions.map((opt) => (
                              <option key={opt.value} value={opt.value}>
                                {opt.label}
                              </option>
                              ))
                              )}
                            </select>
                          </label>       
                          <button type="submit">Search</button>
                        </div>
                      </form>
                      <div className="resource-library-table" style={{ width: '100%', overflowX: 'clip',}}>
                        <DataGrid
                          autoHeight
                          rows={rows}
                          columns={columns.map(col => ({ ...col, filterable: false }))}
                          rowCount={rowCount}
                          getRowHeight={() => 'auto'}
                          paginationMode="server"
                          sortingMode="server"
                          filterMode="server"
                          filterModel={filterModel}
                          onFilterModelChange={setFilterModel}
                          paginationModel={paginationModel}
                          onPaginationModelChange={setPaginationModel}
                          sortModel={sortModel}
                          onSortModelChange={setSortModel}
                          onRowSelectionModelChange={(ids) => setSelectedRows(ids)}
                          pageSizeOptions={[5, 10, 25, 50]}
                          pageSize={50}
                          getRowId={() => crypto.randomUUID()}  
                          columnVisibilityModel={columnVisibilityModel}                                                               
                          sx={{
                            fontFamily: '"Open Sans", sans-serif, Arial, Verdana',
                            '& .MuiDataGrid-row': { marginTop: 1, marginBottom: 1 },
                            '& .coloured': { textAlign: 'center', color: '#7181AD' },
                            '& .MuiDataGrid-virtualScroller::-webkit-scrollbar': { display: 'block' },
                            '& .super-app-theme--header': { fontSize: '14px' },
                            '.MuiDataGrid-columnHeaderTitle': { fontWeight: 'bold !important',whiteSpace:'normal' },
                            '& .MuiDataGrid-cell': {
                              whiteSpace: 'normal',
                              wordWrap: 'break-word',
                              lineHeight: '1.4',
                              alignItems: 'center',
                              display: 'flex',
                            },
                            '& .MuiTablePagination-actions': { marginRight: 10 },
                            '& .header-link':{color: "#2C99D2"},
                          }}
                        />
                      </div>  
                </div>
              )}
            </div>
            <div className="right">
              {
                userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) ||
                userLoggedInRoles.includes(configData.ROLE_SAADMIN) ||
                userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE)
                  ? <SalespersonSidebar />

                  : domainName === configData.RSMWW_AGENCY_DOMAIN &&
                    userLoggedInRoles.includes(configData.ROLE_AGENT)
                  ? <AgentBackendSidebar />

                  : domainName === configData.RSMWW_SCOUT_DOMAIN &&
                    userLoggedInRoles.includes(configData.ROLE_SCOUT)
                  ? <ScoutSidebar />

                  : null
              }
              <>
                <p>
                  <img src="/basic/web/images/folderopen.gif" /> Folder<br />
                  <img src="/basic/web/images/file.gif" /> Download File<br />
                  <img src="/basic/web/images/link.gif" /> Link
                </p>
              </>
            </div>
        </div>
    );
};
export default ResourceLibrary;